import { UserContext } from "contexts/MightyTool";
import { useContext } from "react";
const useUser = () => useContext(UserContext);
export default useUser;
